import { __rest } from "tslib";
import { NonDismissibleAlert } from './NonDismissibleAlert';
import { Collapse } from 'react-collapse';
import React from 'react';
import { CrossIcon } from '../../assets/svgs';
import { BodyText } from '../Type';
import clsx from 'clsx';
import './DismissibleAlert.less';
export const DismissibleAlert = (_a) => {
    var { dismissButtonText, isOpen, onDismiss, children, noTopSpacer, className } = _a, otherProps = __rest(_a, ["dismissButtonText", "isOpen", "onDismiss", "children", "noTopSpacer", "className"]);
    return (React.createElement(Collapse, { isOpened: isOpen, theme: {
            collapse: clsx('kal-dismissible-alert', noTopSpacer && `kal-no-top-spacer`),
        } },
        React.createElement(NonDismissibleAlert, Object.assign({ className: clsx(className, 'kal-no-top-spacer') }, otherProps),
            children,
            React.createElement("button", { type: 'button', onClick: onDismiss, className: 'kal-dismissible-alert__dismiss-button' },
                React.createElement(CrossIcon, { height: '24px', width: '24px' }),
                React.createElement(BodyText, { noTopSpacer: true }, dismissButtonText)))));
};
//# sourceMappingURL=DismissibleAlert.js.map